<template>
  <el-container style="width: 980px; margin:auto;">
    <el-main>
      <h1 class="text-center" style="margin: 40px 0;">{{commerceInfo.commerce_name}}信息库</h1>
      <el-tabs v-model="activeName">
          <el-tab-pane label="个人信息" name="first">
            <el-row>
              <el-col :span="24">
                <el-card
                  class="box-card"
                  shadow="never"
                  :body-style="{padding: '20px 0'}"
                >
                  <div slot="header" class="clearfix">
                    <el-button @click="handleOpen('base')" style="float: right; padding: 9px 0 0; font-weight: 400; font-size:18px;" type="text">
                      编辑
                      <i class="el-icon-edit"></i>
                    </el-button>
                    <h2 style="float: left; margin: 0;">基本信息</h2>
                  </div>
                  <el-row>
                    <el-col :span="6">
                      <el-avatar shape="square" :size="100" fit="fit" :src="baseInfo.avatar"></el-avatar>
                    </el-col>
                    <el-col :span="18">
                      <el-row>
                        <el-col :span="12">
                          <p>姓名: {{baseInfo.real_name}}</p>
                        </el-col>
                        <el-col :span="12">
                          <p>性别: {{gender}}</p>
                        </el-col>
                        <el-col :span="12">
                          <p>生日: {{baseInfo.birthday}}</p>
                        </el-col>
                        <el-col :span="12">
                          <p>民族: {{famous_family}}</p>
                        </el-col>
                        <el-col :span="12">
                          <p>学历: {{education}}</p>
                        </el-col>
                        <el-col :span="12">
                          <p>政治面貌: {{polutical_status}}</p>
                        </el-col>
                        <el-col :span="24">
                          <p>籍贯: {{baseInfo.birth_province_name}} {{baseInfo.birth_city_name}}</p>
                        </el-col>
                        <el-col :span="24">
                          <p>微信号: {{baseInfo.weixin_id}}</p>
                        </el-col>
                        <el-col :span="24">
                          <p>手机号: {{baseInfo.mobile}}</p>
                        </el-col>
                        <el-col :span="24">
                          <p>身份证: {{baseInfo.id_card}}</p>
                        </el-col>
                        <el-col :span="24">
                          <p>个人标签: {{baseInfo.person_tag}}</p>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="24">
                      <p>兴趣爱好: {{interest}}</p>
                    </el-col>
                    <el-col :span="24">
                      <p>专业特长: {{speciallty}}</p>
                    </el-col>
                  </el-row>
                </el-card>
              </el-col>
              <el-col :span="24">
                <el-card
                  class="box-card"
                  shadow="never"
                  :body-style="{padding: '20px 0'}"
                >
                  <div slot="header" class="clearfix">
                    <el-button @click="handleOpen('assistant')" style="float: right; padding: 9px 0 0; font-weight: 400; font-size:18px;" type="text">
                      编辑
                      <i class="el-icon-edit"></i>
                    </el-button>
                    <h2 style="float: left; margin: 0;">助理信息</h2>
                  </div>
                  <el-row>
                    <el-col v-for="(item, index) in assistantList" :key="index" :span="24">
                      <h3>{{item.name}} <small>{{item.position}} {{item.phone}}</small></h3>
                    </el-col>
                  </el-row>
                </el-card>
              </el-col>
              <el-col :span="24">
                <el-card
                  class="box-card"
                  shadow="never"
                  :body-style="{padding: '20px 0'}"
                >
                  <div slot="header" class="clearfix">
                    <el-button @click="handleOpen('address')" style="float: right; padding: 9px 0 0; font-weight: 400; font-size:18px;" type="text">
                      编辑
                      <i class="el-icon-edit"></i>
                    </el-button>
                    <h2 style="float: left; margin: 0;">通讯地址</h2>
                  </div>
                  <el-row>
                    <el-col :span="24">
                      <h3>家庭地址</h3>
                      <p v-for="(item, index) in address1" :key="index">{{item.province_name}}{{item.city_name}}{{item.county_name}}{{item.remark}}</p>
                    </el-col>
                    <el-col :span="24">
                      <h3>收件地址</h3>
                      <p v-for="(item, index) in address2" :key="index">{{item.province_name}}{{item.city_name}}{{item.county_name}}{{item.remark}}</p>
                    </el-col>
                    <el-col :span="24">
                      <h3>其他地址</h3>
                      <p v-for="(item, index) in address3" :key="index">{{item.province_name}}{{item.city_name}}{{item.county_name}}{{item.remark}}</p>
                    </el-col>
                  </el-row>
                </el-card>
              </el-col>
              <el-col :span="24">
                <el-card
                  class="box-card"
                  shadow="never"
                  :body-style="{padding: '20px 0'}"
                >
                  <div slot="header" class="clearfix">
                    <el-button @click="handleOpen('honor')" style="float: right; padding: 9px 0 0; font-weight: 400; font-size:18px;" type="text">
                      编辑
                      <i class="el-icon-edit"></i>
                    </el-button>
                    <h2 style="float: left; margin: 0;">个人荣誉</h2>
                  </div>
                  <el-row>
                    <el-col v-for="(item, index) in honorList" :key="index" :span="24">
                      <h3>{{item.name}} <small>{{item.start_date}}至{{item.end_date}}</small></h3>
                    </el-col>
                  </el-row>
                </el-card>
              </el-col>
              <el-col :span="24">
                <el-card
                  class="box-card"
                  shadow="never"
                  :body-style="{padding: '20px 0'}"
                >
                  <div slot="header" class="clearfix">
                    <el-button @click="handleOpen('school')" style="float: right; padding: 9px 0 0; font-weight: 400; font-size:18px;" type="text">
                      编辑
                      <i class="el-icon-edit"></i>
                    </el-button>
                    <h2 style="float: left; margin: 0;">学习经历</h2>
                  </div>
                  <el-row>
                    <el-col v-for="(item, index) in schoolList" :key="index" :span="24">
                      <h3>{{item.school}} <small>{{item.start_date}}至{{item.end_date}}</small></h3>
                      <p>学历: {{item.education}}</p>
                      <p>专业: {{item.profession}}</p>
                    </el-col>
                  </el-row>
                </el-card>
              </el-col>
              <el-col :span="24">
                <el-card
                  class="box-card"
                  shadow="never"
                  :body-style="{padding: '20px 0'}"
                >
                  <div slot="header" class="clearfix">
                    <el-button @click="handleOpen('work')" style="float: right; padding: 9px 0 0; font-weight: 400; font-size:18px;" type="text">
                      编辑
                      <i class="el-icon-edit"></i>
                    </el-button>
                    <h2 style="float: left; margin: 0;">工作经历</h2>
                  </div>
                  <el-row>
                    <el-col v-for="(item, index) in workList" :key="index" :span="24">
                      <h3>{{item.company_name}} <small>{{item.start_date}}至{{item.end_date}}</small></h3>
                      <p>职务: {{item.position}}</p>
                      <p>主要工作: {{item.main_work}}</p>
                    </el-col>
                  </el-row>
                </el-card>
              </el-col>
              <el-col :span="24">
                <el-card
                  class="box-card"
                  shadow="never"
                  :body-style="{padding: '20px 0'}"
                >
                  <div slot="header" class="clearfix">
                    <el-button @click="handleOpen('position', 1)" style="float: right; padding: 9px 0 0; font-weight: 400; font-size:18px;" type="text">
                      编辑
                      <i class="el-icon-edit"></i>
                    </el-button>
                    <h2 style="float: left; margin: 0;">人大职务</h2>
                  </div>
                  <el-row>
                    <el-col v-for="(item, index) in positionList1" :key="index" :span="24">
                      <h3>{{item.position_name}} <small>{{item.start_date}}至{{item.end_date}}</small></h3>
                    </el-col>
                  </el-row>
                </el-card>
              </el-col>
              <el-col :span="24">
                <el-card
                  class="box-card"
                  shadow="never"
                  :body-style="{padding: '20px 0'}"
                >
                  <div slot="header" class="clearfix">
                    <el-button @click="handleOpen('position', 2)" style="float: right; padding: 9px 0 0; font-weight: 400; font-size:18px;" type="text">
                      编辑
                      <i class="el-icon-edit"></i>
                    </el-button>
                    <h2 style="float: left; margin: 0;">政协职务</h2>
                  </div>
                  <el-row>
                    <el-col v-for="(item, index) in positionList2" :key="index" :span="24">
                      <h3>{{item.position_name}} <small>{{item.start_date}}至{{item.end_date}}</small></h3>
                    </el-col>
                  </el-row>
                </el-card>
              </el-col>
              <el-col :span="24">
                <el-card
                  class="box-card"
                  shadow="never"
                  :body-style="{padding: '20px 0'}"
                >
                  <div slot="header" class="clearfix">
                    <el-button @click="handleOpen('position', 3)" style="float: right; padding: 9px 0 0; font-weight: 400; font-size:18px;" type="text">
                      编辑
                      <i class="el-icon-edit"></i>
                    </el-button>
                    <h2 style="float: left; margin: 0;">其他社会职务</h2>
                  </div>
                  <el-row>
                    <el-col v-for="(item, index) in positionList3" :key="index" :span="24">
                      <h3>{{item.position_name}} <small>{{item.start_date}}至{{item.end_date}}</small></h3>
                    </el-col>
                  </el-row>
                </el-card>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="企业信息" name="second">
            <company></company>
          </el-tab-pane>
        </el-tabs>
    </el-main>
    <el-drawer
      size="470px"
      :with-header="false"
      :visible="drawer"
      :direction="direction"
      :before-close="handleClose">
        <base-info
          v-if="openType=='base'"
          @cancel="handleClose"
          @success="updateSuccess"
          :infos="baseInfo"
        ></base-info>
        <address-box
          v-if="openType=='address'"
          :list="addressList"
          @cancel="handleClose"
          @success="updateAddressListOrigin"
        ></address-box>
        <honor
          v-if="openType=='honor'"
          :list="honorList"
          @success="updateHonorListOrigin"
          @cancel="handleClose"
        ></honor>
        <school
          v-if="openType=='school'"
          :list="schoolList"
          @success="updateSchoolListOrigin"
          @cancel="handleClose"
        ></school>
        <work
          v-if="openType=='work'"
          :list="workList"
          @success="updateWorkListOrigin"
          @cancel="handleClose"
        ></work>
        <position
          v-if="openType=='position'"
          :position-name="positionName"
          :position-type="positionType"
          :list="positionList"
          @success="updatePositionListOrigin(positionType)"
          @cancel="handleClose"
        ></position>
        <assistant
          v-if="openType=='assistant'"
          :list="assistantList"
          @success="updateAssistantListOrigin()"
          @cancel="handleClose"
        ></assistant>
    </el-drawer>
  </el-container>
</template>

<script>
import base from "./components/base.vue";
import address from "./components/address.vue";
import honor from "./components/honor.vue";
import school from "./components/school.vue";
import work from "./components/work.vue";
import position from "./components/position.vue";
import assistant from "./components/assistant.vue";
import company from "./components/company.vue";
import { mapState, mapActions } from "vuex";
export default {
  name: "info",
  components:{
    baseInfo: base,
    addressBox: address,
    honor,
    school,
    work,
    position,
    assistant,
    company
  },
  computed:{
    ...mapState([
      "baseInfo",
      "defaultInfo",
      "addressList",
      "areaDefault",
      "honorList",
      "schoolList",
      "workList",
      "positionList1",
      "positionList2",
      "positionList3",
      "assistantList",
      "commerceInfo"
    ]),
    address1(){
      return this.addressList.filter(v=>v.type==1).map(v=>{
        v.province_name = this.areaDefault&&this.areaDefault.province_list&&this.areaDefault.province_list[v.province_id];
        v.city_name = this.areaDefault&&this.areaDefault.city_list&&this.areaDefault.city_list[v.city_id];
        v.county_name = this.areaDefault&&this.areaDefault.county_list&&this.areaDefault.county_list[v.county_id];
        return v;
      });
    },
    address2(){
      return this.addressList.filter(v=>v.type==2).map(v=>{
        v.province_name = this.areaDefault&&this.areaDefault.province_list&&this.areaDefault.province_list[v.province_id];
        v.city_name = this.areaDefault&&this.areaDefault.city_list&&this.areaDefault.city_list[v.city_id];
        v.county_name = this.areaDefault&&this.areaDefault.county_list&&this.areaDefault.county_list[v.county_id];
        return v;
      });
    },
    address3(){
      return this.addressList.filter(v=>v.type==3).map(v=>{
        v.province_name = this.areaDefault&&this.areaDefault.province_list&&this.areaDefault.province_list[v.province_id];
        v.city_name = this.areaDefault&&this.areaDefault.city_list&&this.areaDefault.city_list[v.city_id];
        v.county_name = this.areaDefault&&this.areaDefault.county_list&&this.areaDefault.county_list[v.county_id];
        return v;
      });
    },
    gender(){
      return this.defaultInfo?this.defaultInfo.gender[this.baseInfo.gender]:"";
    },
    education(){
      return this.defaultInfo?this.defaultInfo.education[this.baseInfo.education]:"";
    },
    polutical_status(){
      return this.defaultInfo?this.defaultInfo.polutical_status[this.baseInfo.polutical_status]:"";
    },
    famous_family(){
      return this.defaultInfo?this.defaultInfo.nation[this.baseInfo.famous_family]:"";
    },
    interest(){
      const interest = [];
      if (this.defaultInfo&&this.defaultInfo.interest) {
        for (let key in this.defaultInfo.interest) {
          if (this.baseInfo.interest.split(',').includes(key)) {
            interest.push(this.defaultInfo.interest[key]);
          }
        }
      }
      return interest.join(',');
    },
    speciallty(){
      const speciallty = [];
      if (this.defaultInfo&&this.defaultInfo.specialty) {
        for (let key in this.defaultInfo.specialty) {
          if (this.baseInfo.speciallty.split(',').includes(key)) {
            speciallty.push(this.defaultInfo.specialty[key]);
          }
        }
      }
      return speciallty.join(',');
    },
    positionName(){
      return this.positionType==1?"人大":this.positionType==2?"政协":this.positionType==3?"社会":"";
    },
    positionList(){
      return this.positionType==1?this.positionList1:this.positionType==2?this.positionList2:this.positionType==3?this.positionList3:[]; 
    }
  },
  data() {
    return {
      drawer: false,
      direction: 'rtl',
      openType: '',
      positionType: '',
      activeName: 'first'
    };
  },
  methods:{
    ...mapActions([
      "updateOrigin",
      "getArea",
      "updateMoreOrigin",
      "updateAddressListOrigin",
      "updateHonorListOrigin",
      "updateSchoolListOrigin",
      "updateWorkListOrigin",
      "updatePositionListOrigin",
      "updateAssistantListOrigin"
    ]),
    handleOpen(type, positionType) {
      if (positionType) {
        this.positionType = positionType;
      }
      this.openType = type;
      this.drawer = true;
    },
    handleClose() {
      this.drawer = false;
    },
    updateSuccess(){
      this.handleClose();
      this.updateOrigin();
    }
  },
  created(){
    this.updateOrigin();
    this.getArea();
    this.updateMoreOrigin();
    this.updateAddressListOrigin();
    this.updateHonorListOrigin();
    this.updateSchoolListOrigin();
    this.updateWorkListOrigin();
    this.updatePositionListOrigin(1);
    this.updatePositionListOrigin(2);
    this.updatePositionListOrigin(3);
    this.updateAssistantListOrigin();
  }
};
</script>

<style lang="less" scoped>
  /deep/.el-drawer__body {
    height: 100%;
    overflow: auto;
  }
  .box-card {
    border: none;
    /deep/.el-card__header {
      padding-left: 0;
      padding-right: 0;
    }
    p {
      padding: 0;
      margin: 0 0 10px;
    }
  }
</style>
